import { DateRangePicker, Stack } from 'rsuite';
import subDays from 'date-fns/subDays';
import startOfWeek from 'date-fns/startOfWeek';
import endOfWeek from 'date-fns/endOfWeek';
import addDays from 'date-fns/addDays';
import startOfMonth from 'date-fns/startOfMonth';
import endOfMonth from 'date-fns/endOfMonth';
import addMonths from 'date-fns/addMonths';
import 'rsuite/DateRangePicker/styles/index.css';
import '../styles/components/DatePicker.scss'
import {
  startOfQuarter,
  endOfQuarter,
  subQuarters,
} from 'date-fns';

const now=new Date()
const getThisQuarterDates = () => {
  const month = now.getMonth(); 
  const year = now.getFullYear();

  let start, end;

  if (month < 3) {
    
    start = new Date(year, 0, 1);
    end = new Date(year, 2, 31);
  } else if (month < 6) {
   
    start = new Date(year, 3, 1);
    end = new Date(year, 5, 30);
  } else if (month < 9) {
    
    start = new Date(year, 6, 1);
    end = new Date(year, 8, 30);
  } else {
    
    start = new Date(year, 9, 1);
    end = new Date(year, 11, 31);
  }

  
  const safeEnd = now < end ? now : end;

  return [start, safeEnd];
};

const predefinedRanges = [
  {
    label: 'Today',
    value: [new Date(), new Date()],
    placement: 'left'
  },
  {
    label: 'Yesterday',
    value: [addDays(new Date(), -1), addDays(new Date(), -1)],
    placement: 'left'
  },
  {
    label: 'This week',
    value: [startOfWeek(new Date()),new Date()],
    placement: 'left'
  },
  {
    label: 'Last 7 days',
    value: [subDays(new Date(), 6), new Date()],
    placement: 'left'
  },
  {
    label: 'Last 30 days',
    value: [subDays(new Date(), 29), new Date()],
    placement: 'left'
  },
  {
    label: 'This month',
    value: [startOfMonth(new Date()), new Date()],
    placement: 'left'
  },
  {
    label: 'Last month',
    value: [startOfMonth(addMonths(new Date(), -1)), endOfMonth(addMonths(new Date(), -1))],
    placement: 'left'
  },
  
  {
    label: 'This Quarter',
    value: getThisQuarterDates(),
    placement: 'left'
  },
  {
    label: 'Last Quarter',
    value: [
      startOfQuarter(subQuarters(new Date(), 1)),
      endOfQuarter(subQuarters(new Date(), 1))
    ],
    placement: 'left'
  },
  {
    label: 'Last 6 Months',
    value: [
        new Date(new Date().getFullYear(), new Date().getMonth() - 6, 1),
        new Date(new Date().getFullYear(), new Date().getMonth(), 0)
    ],
    placement: 'left'
},
  {
    label: 'This year',
    value: [new Date(new Date().getFullYear(), 0, 1), new Date()],
    placement: 'left'
  },
  {
    label: 'Clear',
    value: null,
    placement: 'left'
  },
  {
    label: 'Last week',
    closeOverlay: false,
    value: value => {
      const [start = new Date()] = value || [];
      return [
        addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
        addDays(endOfWeek(start, { weekStartsOn: 0 }), -7)
      ];
    },
    appearance: 'default'
  },
  {
    label: 'Next week',
    closeOverlay: false,
    value: value => {
      const [start = new Date()] = value || [];
      return [
        addDays(startOfWeek(start, { weekStartsOn: 0 }), 7),
        addDays(endOfWeek(start, { weekStartsOn: 0 }), 7)
      ];
    },
    appearance: 'default'
  }
];


const NewDateandTimePicker = ({onDateRangeChange,value}) => {
  const disableFutureDates = (date) => {
    return date > new Date(); 
  };
  
  return(
    
    <Stack  direction="column" spacing={8} alignItems="flex-start">
      <DateRangePicker
      placement="bottomEnd" 
        ranges={predefinedRanges}
        className='custom-date-range'
        showOneCalendar
        allowClear
        placeholder="Select Date Range"
        style={{ width: '100%' }}
        value={value}
        shouldDisableDate={disableFutureDates }
        onChange={onDateRangeChange}
        onShortcutClick={(shortcut, event) => {
          if (shortcut.label === 'Clear') {
            onDateRangeChange(null); 
          }
          console.log(shortcut);
        }}
      />
    </Stack>

  )
    };

export default NewDateandTimePicker;